import BriefGuide from '@elem/compCommon/ProductConstructor/BriefGuide';
import ApplyRebstesPopUp from '@elem/compCommon/ProductConstructor/BriefGuide/ApplyRebstesPopUp';
import DownloadTheCertificates from '@elem/compCommon/ProductConstructor/BriefGuide/Info/DownloadTheCertificates';
import ProductBundles from '@elem/compCommon/ProductConstructor/Bundles';
import ProductMedia from '@elem/compCommon/ProductConstructor/Media';
import ProductMenu from '@elem/compCommon/ProductConstructor/Menu';
import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import ProductSupport from '@elem/compCommon/ProductConstructor/Support';
import EcoLink from 'eco-design/base/eco-link';
import { useRef } from 'react';
import { createPortal } from 'react-dom';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import USInstallation from '@elem/compCommon/ProductConstructor/BriefGuide/Info/Icons/USInstallation';
import USIRA from '@elem/compCommon/ProductConstructor/BriefGuide/Info/Icons/USIRA';
import USConsulting from '@elem/compCommon/ProductConstructor/BriefGuide/Info/Icons/USConsulting';
import USArea from '@elem/compCommon/ProductConstructor/BriefGuide/Info/Icons/USArea';
import USHelp from '@elem/compCommon/ProductConstructor/BriefGuide/Info/Icons/USHelp';
import USSupport from '@elem/compCommon/ProductConstructor/BriefGuide/Info/Icons/USSupport';
import { useSupportData } from '@/utils/hooks';
import { getProductMsg } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import BundlePopup from './BundlePopup';
import ProductDetail from './Detail';
import InstallationTips from './InstallationTips';
import PostcodeQueryPopUp from './PostcodeQueryPopUp';
import css from './index.module.scss';
import Bundles from './Bundles';
import TC_Footer from './Detail/componentsAU/TC_Footer';

const EU_SITES: string[] = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'];
export type SupportRefType = {
    handleChangeFolder: () => void;
};

// 产品详情页参数
export default function DeltaProUltraLaunch({ theme, productMsg }: any) {
    const { useState, useRouter, useEffect, gtm } = useGlobal();
    const router = useRouter();
    const { locale, query, pathname } = router;
    const SITE_JP = 'jp';
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const [freeQuote, setFreeQuote] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [showBundlePop, setShowBundlePop] = useState(false);
    const [showInstallationTips, setShowInstallationTips] = useState(false);
    const [showPostcodeQueryPopUp, setShowPostcodeQueryPopUp] = useState(false);
    const [feePop, setFeePop] = useState(false);
    const [supportActive, setsupportActive] = useState();
    const [bundlePopupKey, setBundlePopupKey] = useState(-1);
    const [installationTipsPopupKey, setInstallationTipsPopupKey] = useState(-1);
    const supportRef = useRef<SupportRefType>(null);
    const [showQuote, setShowQuote] = useState(false);
    const [openApplyRebstes, setOpenApplyRebstes] = useState(false);
    // let scrollY: number = 150;
    // let timer: NodeJS.Timeout | number | null = null;
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg, productMsg?.spuId || productMsg?.sourceId);
    const links: {
        [key: string]: any;
    } = {
        us: {
            link: { type: 1, text: 'How Does It Work?' },
            button: { type: 1, text: 'Get a FREE Installation Consult' },
        },
        ca: {
            link: { type: 3, text: 'How to apply rebates?' },
            button: { type: 3, text: 'Get a Free Quote' },
        },
    };
    const usSwiper = [
        {
            img: '/responsive/picture/delta-pro-ultra/launch/swiper1.png',
            imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper1_768.png',
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1748317550658/Frame%201612707565.jpg`,
            imgPad: `https://websiteoss.ecoflow.com/upload/image/1748317574083/Frame%201612707577.jpg`,
        },
        {
            img: `https://websiteoss.ecoflow.com/upload/image/1747996677842/Frame%201612707586.jpg`,
            imgPad: `https://websiteoss.ecoflow.com/upload/image/1747996677993/Frame%201612707589.jpg`,
        },
        {
            img: '/responsive/picture/delta-pro-ultra/launch/swiper3.jpg',
            imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper3_768.jpg',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1756953742718/pc.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1756953742915/pad.jpg',
            imgMobile: 'https://websiteoss.ecoflow.com/upload/image/1756953743133/h5.jpg',
        },
    ];
    const data: any = {
        langKey: 'delta_pro_ultra.launch',
        briefGuide: {
            swiper:
                locale === 'us'
                    ? usSwiper
                    : [
                          {
                              img: `https://websiteoss.ecoflow.com/upload/image/1747102418752/Frame%201612707013.png`,
                              imgPad: `https://websiteoss.ecoflow.com/upload/image/1747102418752/Frame%201612707013.png`,
                          },
                          {
                              img: '/responsive/picture/delta-pro-ultra/launch/swiper1.png',
                              imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper1_768.png',
                          },

                          {
                              img: '/responsive/picture/delta-pro-ultra/launch/swiper3.jpg',
                              imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper3_768.jpg',
                          },
                          {
                              img: '/responsive/picture/delta-pro-ultra/launch/swiper6.jpg',
                              imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper6_768.jpg',
                          },
                          {
                              img: '/responsive/picture/delta-pro-ultra/launch/swiper4.jpg',
                              imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper4_768.jpg',
                          },
                          {
                              img: '/responsive/picture/delta-pro-ultra/launch/swiper5.jpg',
                              imgPad: '/responsive/picture/delta-pro-ultra/launch/swiper5_768.jpg',
                          },
                      ],
            info: {
                title: 'brief_guide.info.title',
                desc: 'brief_guide.info.desc',
                textArr: ['brief_guide.info.text1', 'brief_guide.info.text2', 'brief_guide.info.text3', 'brief_guide.info.text4', 'brief_guide.info.text5'],
                tip: 'brief_guide.info.tip',
                // priceTip: 'brief_guide.info.priceTip',
                // tel: 'brief_guide.info.tel',
                productId: (() => {
                    const localMap: any = {
                        us: '6964802453577',
                        ca: '8006700236954',
                    };
                    return localMap[locale] || undefined;
                })(),
                variantId: (() => {
                    const localMap: any = {
                        us: '40758830071881',
                        ca: '44244774650010',
                    };
                    return localMap[locale] || undefined;
                })(),
                code: 'brief_guide.info.code',
                codeId: 'brief_guide.info.codeId',
                features:
                    locale === 'us'
                        ? [
                              {
                                  icon: <USInstallation />,
                                  text: 'icon_free',
                                  details: 'Starting at $484/mo or 0% APR with ',
                              },
                              {
                                  icon: <USIRA />,
                                  text: 'icon_tax_refund',
                                  details:
                                      'The Federal Solar Tax Credit, or Residential Clean Energy Credit, offers a 30% financial incentive for US taxpayers installing residential solar energy systems, including battery storage technology with a capacity above 3kWh. This credit helps offset upfront costs, making both solar and storage solutions more accessible for homeowners.',
                              },
                              {
                                  icon: <USConsulting />,
                                  text: 'icon_service',
                                  details: true,
                                  href: 'https://us.ecoflow.com/products/installation-service',
                              },
                              {
                                  icon: <USArea />,
                                  text: 'icon_area',
                                  details: true,
                              },
                              {
                                  icon: <USHelp />,
                                  text: 'icon_help',
                                  details: true,
                              },
                              {
                                  icon: <USSupport />,
                                  text: 'icon_support',
                                  details: true,
                              },
                          ]
                        : undefined,
            },
            popup: [
                { question: 'brief_guide.popup.q1', answer: 'brief_guide.popup.a1', img: '/responsive/picture/delta-pro-ultra/launch/popup_1.jpg' },
                { question: 'brief_guide.popup.q2', answer: 'brief_guide.popup.a2' },
                { question: 'brief_guide.popup.q3', answer: 'brief_guide.popup.a3' },
                { question: 'brief_guide.popup.q4', answer: 'brief_guide.popup.a4' },
            ],
        },
        bar: {
            text: 'bar.text',
            auto_copy: 'bar.auto_copy',
            codeId: 'brief_guide.info.codeId',
        },
        menu: {
            title:
                pathname === '/dpu-home-solution' || locale === 'au'
                    ? 'menu.dpu'
                    : [
                          { product: 'menu.dpu', url: `/${locale}/delta-pro-ultra` },
                          { product: 'menu.shp2', url: `/${locale}/smart-home-panel-2?withHeader=1` },
                      ],
            buyText: locale === 'au' ? 'Shop Now' : undefined,
        },
        bundles: {
            data: [
                {
                    title: 'bundles.bundle1_title',
                    name: 'bundles.bundle1_name',
                    power: 'bundles.bundle1_power',
                    desc: 'bundles.bundle1_desc',
                    img: '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    install: locale === 'us',
                    link: locale === 'ca' ? links?.[locale]?.link : '',
                    button: locale === 'ca' ? links?.[locale]?.button : '',
                    productId: (() => {
                        const localMap: any = {
                            us: '6972483010633',
                            ca: '8308553515162',
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '40790293184585',
                            ca: '45100148555930',
                            au: '44762205061318',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs:
                        locale === 'au'
                            ? null
                            : [
                                  {
                                      subtitle: 'bundles.subs.subtitle',
                                      title: 'bundles.subs.battery',
                                      img: '/responsive/picture/common-products/DPU_Battery.png',
                                      limit: 4,
                                      parentVariantId: (() => {
                                          const localMap: any = {
                                              us: '40790293184585',
                                              ca: '44286125047962',
                                              jp: '43695281438881',
                                          };
                                          return localMap[locale] || undefined;
                                      })(),
                                      productId: (() => {
                                          const LocalMap: any = {
                                              us: '6965707112521',
                                              ca: '8012436209818',
                                          };
                                          return LocalMap[locale] || LocalMap.us;
                                      })(),
                                      variantId: (() => {
                                          const LocalMap: any = {
                                              us: '41446274465865',
                                              ca: '44960085639322',
                                          };
                                          return LocalMap[locale] || LocalMap.us;
                                      })(),
                                  },
                              ],
                },
                {
                    title: 'bundles.bundle2_title',
                    name: 'bundles.bundle2_name',
                    power: 'bundles.bundle2_power',
                    desc: 'bundles.bundle2_desc',
                    img: `/responsive/picture/common-products/bundle_intelligent_kit.png`,
                    install: locale === 'us',
                    link: locale === 'us' || locale === 'ca' ? links?.[locale]?.link : '',
                    button: locale === 'us' || locale === 'ca' ? links?.[locale]?.button : '',
                    productId: (() => {
                        const localMap: any = {
                            us: '6972484026441',
                            ca: '8006700236954',
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '40790304063561',
                            ca: '44244774682778',
                            au: '44762205094086',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs:
                        locale === 'au'
                            ? null
                            : [
                                  {
                                      subtitle: 'bundles.subs.subtitle',
                                      title: 'bundles.subs.battery',
                                      img: '/responsive/picture/common-products/DPU_Battery.png',
                                      limit: 4,
                                      parentVariantId: (() => {
                                          const localMap: any = {
                                              us: '40790304063561',
                                              ca: '44286125965466',
                                          };
                                          return localMap[locale] || undefined;
                                      })(),
                                      productId: (() => {
                                          const LocalMap: any = {
                                              us: '6965707112521',
                                              ca: '8012436209818',
                                          };
                                          return LocalMap[locale] || LocalMap.us;
                                      })(),
                                      variantId: (() => {
                                          const LocalMap: any = {
                                              us: '41446274465865',
                                              ca: '44960085639322',
                                          };
                                          return LocalMap[locale] || LocalMap.us;
                                      })(),
                                  },
                              ],
                },
                {
                    title: 'bundles.bundle3_title',
                    name: 'bundles.bundle3_name',
                    power: 'bundles.bundle3_power',
                    desc: 'bundles.bundle3_desc',
                    ship: 'bundles.bundle3_ship',
                    install: locale == 'us',
                    link: locale === 'us' ? { type: 2, text: 'How Does It Work?' } : '',
                    install_title: locale === 'us' ? 'bundles.install_title' : undefined,
                    install_link: locale === 'us' ? 'https://us.ecoflow.com/products/installation-service' : undefined,
                    install_link_text: locale === 'us' ? 'bundles.install_link_text' : undefined,
                    button: locale === 'us' ? { type: 2, text: 'Check Installation Service Area' } : '',
                    // 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719802008133/test2.png'
                    img:
                        locale === 'us'
                            ? 'https://websiteoss.ecoflow.com/upload/image/1727055464404/hassle-free.png'
                            : '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            jp: '7835103494305',
                            us: '7013514936393',
                            ca: '8006700236954',
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            jp: '43695279997089',
                            us: '40944017440841',
                            ca: '44244774650010',
                            au: '44762205126854',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs: ['us'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: 'bundles.subs.battery',
                                  img: '/responsive/picture/common-products/DPU_Battery.png',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '40944017440841',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                },
                {
                    title: 'bundles.bundle4_title',
                    name: 'bundles.bundle4_name',
                    power: 'bundles.bundle4_power',
                    desc: 'bundles.bundle4_desc',
                    img:
                        locale === 'jp'
                            ? '/responsive/picture/delta-pro-ultra/launch/bundle3_jp.png'
                            : '/responsive/picture/common-products/bundle_intelligent_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            jp: '7835105001633',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            jp: '43695280980129',
                        };
                        return localMap[locale] || undefined;
                    })(),
                },
                {
                    title: 'bundles.bundle4_title',
                    name: 'bundles.bundle4_name',
                    power: 'bundles.bundle4_power',
                    desc: 'bundles.bundle4_desc',
                    // ship: 'bundles.bundle3_ship',
                    // install: locale == 'us',
                    // 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719802008133/test2.png'
                    img: '',
                    productId: (() => {
                        const localMap: any = {
                            us: '15332714676297',
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            us: '54475840094281',
                            au: '44762205159622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    subs: ['us'].includes(locale)
                        ? [
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: '',
                                  img: '',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '54475840094281',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6965707112521',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '41446274465865',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                              {
                                  subtitle: 'bundles.subs.subtitle',
                                  title: '',
                                  img: '',
                                  limit: 4,
                                  parentVariantId: (() => {
                                      const localMap: any = {
                                          us: '54475840094281',
                                      };
                                      return localMap[locale] || undefined;
                                  })(),
                                  productId: (() => {
                                      const LocalMap: any = {
                                          us: '6841245925449',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                                  variantId: (() => {
                                      const LocalMap: any = {
                                          us: '40250363478089',
                                      };
                                      return LocalMap[locale] || LocalMap.us;
                                  })(),
                              },
                          ]
                        : null,
                },
                {
                    title: 'bundles.bundle5_title',
                    name: 'bundles.bundle5_name',
                    power: 'bundles.bundle5_power',
                    desc: 'bundles.bundle5_desc',
                    img: '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            au: '44762205192390',
                        };
                        return localMap[locale] || undefined;
                    })(),
                },
                {
                    title: 'bundles.bundle6_title',
                    name: 'bundles.bundle6_name',
                    power: 'bundles.bundle6_power',
                    desc: 'bundles.bundle6_desc',
                    img: '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            au: '44762205225158',
                        };
                        return localMap[locale] || undefined;
                    })(),
                },
                {
                    title: 'bundles.bundle7_title',
                    name: 'bundles.bundle7_name',
                    power: 'bundles.bundle7_power',
                    desc: 'bundles.bundle7_desc',
                    img: '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            au: '44762205257926',
                        };
                        return localMap[locale] || undefined;
                    })(),
                },
                {
                    title: 'bundles.bundle8_title',
                    name: 'bundles.bundle8_name',
                    power: 'bundles.bundle8_power',
                    desc: 'bundles.bundle8_desc',
                    img: '/responsive/picture/common-products/bundle_smart_control_kit.png',
                    productId: (() => {
                        const localMap: any = {
                            au: '8554314727622',
                        };
                        return localMap[locale] || undefined;
                    })(),
                    variantId: (() => {
                        const localMap: any = {
                            au: '44762490077382',
                        };
                        return localMap[locale] || undefined;
                    })(),
                },
            ],
            customize:
                locale === 'us'
                    ? {
                          link: '/customize-bundle-for-dpu',
                          img: '/responsive/picture/common-products/customize_bundle.png',
                      }
                    : null,
            shipping: ['ca'].includes(locale),
        },
        media: {
            mediaBanner: {
                title: 'media.media_title',
                img: '/responsive/picture/delta-pro-ultra/launch/media_banner.jpg',
                imgPad: '/responsive/picture/delta-pro-ultra/launch/media_banner_768.jpg',
            },
            mediaList: [
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media0.jpg',
                    title: 'media.list0',
                    link: 'https://www.youtube.com/embed/JcKq6neGxXk?si=XrB0G7e6w7PcrV31',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media1.jpg',
                    title: 'media.list1',
                    link: 'https://www.youtube.com/embed/i__nMuz6M74?si=veweiOuE3qlS4UdM',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media2.jpg',
                    title: 'media.list2',
                    link: 'https://www.youtube.com/embed/WDGzPCrw7FY?si=iRAw9l_sQQ0wQ5Rd',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media3.jpg',
                    title: 'media.list3',
                    link: 'https://www.youtube.com/embed/TeoXospthac?si=QTzTEJ0JK0XKdjP5',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media4.jpg',
                    title: 'media.list4',
                    link: 'https://www.youtube.com/embed/suphdNkkrN4?si=emJrHJgQ80bjsfX7',
                },
                {
                    poster: '/responsive/picture/delta-pro-ultra/launch/media5.jpg',
                    title: 'media.list5',
                    link: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=sTEedcfu_cIb8LRI',
                },
                {
                    poster: 'https://i.ytimg.com/vi/UveodBII6zY/maxresdefault.jpg',
                    title: 'media.list6',
                    link: 'https://www.youtube.com/embed/UveodBII6zY?si=1lxkxZ6_xeXm6iXc',
                },
                {
                    poster: 'https://i.ytimg.com/vi/9Oow6oYjsVw/maxresdefault.jpg',
                    title: 'media.list7',
                    link: 'https://www.youtube.com/embed/9Oow6oYjsVw?si=pxavuvYWe9nVbOz8',
                },
                {
                    poster: 'https://i.ytimg.com/vi_webp/DPyYHFx-RGo/maxresdefault.webp',
                    title: 'media.list8',
                    link: 'https://www.youtube.com/embed/DPyYHFx-RGo?si=tmLB8eiDO7ZSlMCq',
                },
            ],
        },
    };
    const { briefGuide, langKey, bar, menu, bundles, media } = data;
    const hasSupportFlag =
        supportData?.downloadList?.length > 0 || supportData?.videoList?.length > 0 || supportData?.faqList?.length > 0 || supportData?.onlineList?.length > 0;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const allow_tabs: string[] =
        locale === SITE_JP
            ? ['product', 'bundles', 'support', 'specs']
            : EU_SITES.includes(locale)
            ? ['product', 'support', 'specs']
            : ['product', 'bundles', 'support', 'specs', 'media'];
    const [tab, setTab] = useState(query?.tab && allow_tabs.includes(query?.tab?.toLowerCase()) ? query?.tab?.toLowerCase() : allow_tabs[0]);
    const defaultTabObj: any = {
        product: false,
        bundles: false,
        support: false,
        specs: false,
        media: false,
    };
    const [changedTab, setChangedTab] = useState(
        query?.tab && allow_tabs.includes(query?.tab?.toLowerCase())
            ? { ...defaultTabObj, [query?.tab?.toLowerCase()]: true }
            : { ...defaultTabObj, [allow_tabs[0]]: true },
    );

    const handleScroll = () => {
        if (typeof window !== 'undefined') {
            const barLine = document.querySelector('.top-bar-line') as HTMLElement;
            const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
            if (barLine) {
                window.scrollTo({
                    top: barLine?.offsetTop + (header?.offsetHeight || 0),
                    behavior: 'smooth', // 可选，平滑滚动
                });
            }
        }
    };

    const handleChangeTab = (tab: string) => {
        setTab(tab);
        if (!changedTab[tab]) {
            setChangedTab({ ...changedTab, [tab]: true });
        }
        if (query?.tab) {
            router.push(
                {
                    pathname: router.pathname,
                    query: { tab: tab },
                },
                undefined,
                { shallow: true, replace: true },
            );
        }
        const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
        if (bar) {
            handleScroll();
        } else {
            const menu = document.querySelector('.product-menu') as HTMLElement;
            if (menu) {
                handleScroll(); // 初始滚动到指定元素位置
            }
        }
    };

    const handleCallbackLink = (k: number) => {
        if (k === 3) {
            setOpenApplyRebstes(true);
        } else {
            setShowBundlePop(true);
        }
        setBundlePopupKey(k);
    };

    const handleCallbackButton = (k: number) => {
        if (k === 1) {
            setShowInstallationTips(true);
        } else if (k === 3) {
            setShowQuote(true);
        } else {
            setShowPostcodeQueryPopUp(true);
        }
        setInstallationTipsPopupKey(k);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && allow_tabs?.includes(query?.tab?.toLowerCase())) {
            const bar = document.querySelector('.product-announcement-bar') as HTMLElement;
            if (bar) {
                handleScroll(); // 初始滚动到指定元素位置

                window.addEventListener('load', handleScroll);
                // window.addEventListener('resize', handleScroll);

                return () => {
                    window.removeEventListener('load', handleScroll);
                    // window.removeEventListener('resize', handleScroll);
                };
            } else {
                const menu = document.querySelector('.product-menu') as HTMLElement;
                if (menu) {
                    handleScroll(); // 初始滚动到指定元素位置

                    window.addEventListener('load', handleScroll);

                    return () => {
                        window.removeEventListener('load', handleScroll);
                    };
                }
            }
        }
    }, [allow_tabs, query?.tab]);

    useEffect(() => {
        if (typeof window !== 'undefined' && tab.toLowerCase() === 'bundles' && locale === 'us') {
            const bundles = document.querySelectorAll('.product-bundles .bundles .bundle');
            const toggleBundlePop = () => {
                setShowBundlePop(true);
            };
            if (bundles[2]) {
                const target: HTMLElement | null = bundles[2].querySelector('.bundle-img');
                if (target) {
                    target.style.cursor = 'pointer';
                    target.addEventListener('click', toggleBundlePop);
                    return () => target.removeEventListener('click', toggleBundlePop);
                }
            }
        }
    }, [tab, locale]);

    const handleLinkClick = (item?: any) => {
        saveAICookieForShopify(item?.link_learn_more, locale);

        gtm.push({ event: 'uaEvent', event_name: 'buy', product_name: item?.title, position: 'In-Products Module' });
    };

    return (
        <div className={`delta-pro-ultra-launch ${css['delta-pro-ultra-launch']}`}>
            {!EU_SITES.includes(locale) && locale !== 'au' && (
                <BriefGuide
                    briefGuide={briefGuide}
                    langKey={langKey}
                    callBuy={() => handleChangeTab('bundles')}
                    freeQuoteBack={setFreeQuote}
                    feePop={feePop}
                    callFeePop={setFeePop}
                />
            )}
            <p className="top-bar-line"></p>
            <ProductMenu
                langKey={langKey}
                menu={menu}
                activeTab={tab}
                buyLink={isEU ? productMsg?.buyLink : locale === 'au' ? productMsg?.buyLink || 'https://au.ecoflow.com/products/ecoflow-delta-pro-ultra' : ''}
                callTab={handleChangeTab}
                hideTabs={EU_SITES.includes(locale) ? ['bundles', 'media'] : ['']}
            />
            {changedTab.product && (
                <div className={`tab-container ${tab === 'product' ? 'active' : ''}`}>
                    <ProductDetail freeQuote={freeQuote} freeQuoteBack={setFreeQuote} />
                </div>
            )}
            {changedTab.bundles && (
                <div className={`tab-container ${tab === 'bundles' ? 'active' : ''}`}>
                    {locale === 'au' ? (
                        <Bundles bundles={bundles?.data?.filter((bundle: any) => bundle?.variantId)} />
                    ) : (
                        <ProductBundles
                            langKey={langKey}
                            bundles={bundles?.data?.filter((bundle: any) => bundle?.variantId)}
                            customize={bundles?.customize}
                            shipping={bundles?.shipping}
                            callbackLink={handleCallbackLink}
                            callbackButton={handleCallbackButton}
                            buyComponents={(item, Element) => {
                                const IS_CA = locale === 'ca';
                                return (
                                    <>
                                        {Element}
                                        {IS_CA && (
                                            <EcoLink className="bundle-learn-more" href={item.link_learn_more} onClick={() => handleLinkClick(item)}>
                                                Learn More
                                            </EcoLink>
                                        )}
                                    </>
                                );
                            }}
                        />
                    )}
                    {isClient &&
                        showBundlePop &&
                        createPortal(
                            <BundlePopup
                                bundlePopupKey={bundlePopupKey}
                                callback={() => {
                                    setShowBundlePop(false);
                                    setBundlePopupKey(-1);
                                }}
                            />,
                            document.body,
                        )}
                    {isClient &&
                        showInstallationTips &&
                        installationTipsPopupKey === 1 &&
                        createPortal(
                            <InstallationTips
                                callback={() => {
                                    setShowInstallationTips(false);
                                    setInstallationTipsPopupKey(-1);
                                }}
                            />,
                            document.body,
                        )}
                    {isClient &&
                        showPostcodeQueryPopUp &&
                        // installationTipsPopupKey === 1 &&
                        createPortal(
                            <PostcodeQueryPopUp
                                callback={() => {
                                    setShowPostcodeQueryPopUp(false);
                                    setInstallationTipsPopupKey(-1);
                                }}
                            />,
                            document.body,
                        )}
                </div>
            )}
            {changedTab.support && hasSupportFlag && (
                <div className={`tab-container ${tab === 'support' ? 'active' : ''}`}>
                    <ProductSupport
                        ref={supportRef}
                        supportActive={supportActive}
                        supportData={supportData}
                        theme={theme}
                        spuId={productMsg?.spuId || productMsg?.sourceId}
                    />
                </div>
            )}
            {changedTab.specs && resProductCatagory && productDetail && (
                <div className={`tab-container ${tab === 'specs' ? 'active' : ''}`}>
                    <ProductSpecs productCatagory={resProductCatagory} productDetail={productDetail} theme={theme} />
                </div>
            )}
            {changedTab.media && media?.mediaList?.length > 0 && (
                <div className={`tab-container ${tab === 'media' ? 'active' : ''}`}>
                    <ProductMedia langKey={langKey} mediaBanner={media?.mediaBanner} mediaList={media?.mediaList} theme={theme} />
                    {locale === 'au' && <TC_Footer />}
                </div>
            )}
            {locale === 'ca' && (
                <DownloadTheCertificates
                    callback={() => {
                        handleChangeTab('support');
                        setTimeout(() => {
                            supportRef.current?.handleChangeFolder();
                        }, 100);
                    }}
                ></DownloadTheCertificates>
            )}
            {showQuote && (
                <QuoteWin
                    callback={() => {
                        setShowQuote(false);
                        setBundlePopupKey(-1);
                    }}
                />
            )}
            {openApplyRebstes && locale === 'ca' && (
                <ApplyRebstesPopUp
                    callback={() => {
                        setOpenApplyRebstes(false);
                        setBundlePopupKey(-1);
                    }}
                />
            )}

            <style jsx global>
                {`
                    .festival-bar,
                    .announcement-bar {
                        position: relative;
                    }
                `}
            </style>
        </div>
    );
}
